import {Report} from '@mui/icons-material'

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const thirdPartyReport = {
    id: 'thirdPartyReport',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'thirdPartyReport',
            title: 'Third Party Report',
            type: 'item',
            url: '/thirdPartyReport',
            icon: Report,
            breadcrumbs: false
        },
       
    ]
};

export default thirdPartyReport;
